import styles from './StagingBanner.module.css'

export default function StagingBanner({ environment, revision, gitlabProjectUrl }) {
  // Only show indicator in staging environment
  if (environment !== 'staging') {
    return null
  }

  // Build GitLab commit URL if we have revision and project URL
  const commitUrl = revision && gitlabProjectUrl
    ? `${gitlabProjectUrl}/-/commit/${revision}`
    : null

  // Truncate revision SHA to 8 characters for display
  const shortRevision = revision ? revision.substring(0, 8) : 'local'

  return (
    <div className={styles.indicator} title={`Staging Environment - Revision: ${shortRevision}`}>
      <div className={styles.badge}>
        <span className={styles.label}>STAGING</span>
        {commitUrl ? (
          <a
            href={commitUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.revision}
            onClick={(e) => e.stopPropagation()}
          >
            {shortRevision}
          </a>
        ) : (
          <span className={styles.revision}>{shortRevision}</span>
        )}
      </div>
    </div>
  )
}
